module.exports = __webpack_public_path__ + "static/img/number-file.06ad5eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company-profile/number-file.svg
// module id = Jg0r
// module chunks = 1